import React, { useEffect, useState, useContext } from "react";
import useHttpHook from "../hooks/useHttpHook";
import { MainContext } from "../contexts/MainContext";
import useLanguage from "../hooks/useLanguageHook";
import B3SettingsComponent from "../components/b3/B3SettingsComponent";
import NotSoSmartTableComponent from "../components/notSoSmartTableComponent";

const B3PageComponent = () => {
    const { userData } = useContext(MainContext);
    const { languageData } = useLanguage();
    const { httpRequest } = useHttpHook();
    const [transactions, setTransactions] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userData?.userId) {
            fetchTransactions();
        }
    }, [userData, page]);

    async function fetchTransactions() {
        try {
            setLoading(true);
            const response = await httpRequest("GET", `/b3/users/${userData.userId}/transactions?page=${page}&limit=25`);
            setTransactions(response.transactions);
            setTotalPages(response.pagination.totalPages);
        } catch (error) {
            console.error("Error fetching transactions:", error);
        } finally {
            setLoading(false);
        }
    }

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const tableSettings = {
        noDataMessage: languageData.b3Section.noData,
        columns: {
            data: {
                title: languageData.b3Section.date,
                type: "string",
                sortType: "dateFormat",
                sortFormat: "YYYY-MM-DD",
            },
            ticker: {
                title: languageData.b3Section.ticker,
                type: "string",
            },
            movimentacao: {
                title: languageData.b3Section.transactionType,
                type: "string",
            },
            quantidade: {
                title: languageData.b3Section.quantity,
                type: "number",
            },
            precoUnitario: {
                title: languageData.b3Section.unitPrice,
                type: "number",
                valuePrepareFunction: (value) =>
                    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value),
            },
            valorOperacao: {
                title: languageData.b3Section.totalValue,
                type: "number",
                valuePrepareFunction: (value) =>
                    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value),
            },
            instituicao: {
                title: languageData.b3Section.broker,
                type: "string",
            },
        },
    };

    return (
        <div className="container">
            <div className="columns">
                <div className="column is-4 ">

                    <h2 className="subtitle">{languageData.b3Section.title}</h2>
                    <p>{languageData.b3Section.description}</p>


                </div>
                <div className={"column is-8"}>
                    <B3SettingsComponent/>
                </div>
            </div>

                {/* ✅ File Upload */}


                {/* ✅ Transactions Table */}
                <div className="column is-full">
                    <section className="info-tiles section-smart-table-flex-center-row">
                        <h3 className="subtitle">{languageData.b3Section.transactionsTitle}</h3>
                        {loading ? (
                            <p>{languageData.b3Section.loading}</p>
                        ) : (
                            <>
                                <NotSoSmartTableComponent settings={tableSettings} data={transactions || []}/>

                                <div className="pagination">
                                    <button className="button" onClick={() => handlePageChange(page - 1)}
                                            disabled={page === 1}>
                                        ◀ {languageData.b3Section.prevPage}
                                    </button>
                                    <span>
                                {languageData.b3Section.page} {page} / {totalPages}
                            </span>
                                    <button className="button" onClick={() => handlePageChange(page + 1)}
                                            disabled={page === totalPages}>
                                        {languageData.b3Section.nextPage} ▶
                                    </button>
                                </div>
                            </>
                        )}
                    </section>
                </div>


            </div>
            );
            };

            export default B3PageComponent;
